import React, { useCallback, useEffect, useState } from 'react'

import {
  Card,
  CollapseSearch,
  Row,
  Button,
  SuccessModal,
  Span
} from 'components'
import { useLoading, useAuth, useModal } from 'hooks'
import moment from 'moment'
import { MovDocumentItemServices } from 'services/Supplier/MovDocumentItem'
import {
  AnexoPendencia,
  AttachDocumentsServices,
  PendenciaCollapse
} from 'services/Supplier/ThirdPartyAdministration'
import { COLORS, FORMAT, SPACING } from 'utils'
import { convertBase64, createArrayCopy } from 'utils/functions'

import { SearchPendency, TablePendency } from './components'

export const Pendency: React.FC = () => {
  const {
    user: { IdUsuario }
  } = useAuth()
  const [pesquisaGeralTxt, setPesquisaGeralTxt] = useState<string>('')
  const { setLoading, setMsgErro } = useLoading()
  const { showModal } = useModal()

  // const w = watch("searchGlobal")

  const [pendencias, setPendencias] = useState<
    PendenciaCollapse[] | undefined
  >()
  const [pendenciasFiltred, setPendenciasFiltred] = useState<
    PendenciaCollapse[] | []
  >([])
  const [openSuccess, setOpenSuccess] = useState<boolean>(false)

  const getData = async () => {
    setLoading('loading')

    AttachDocumentsServices()
      .get(IdUsuario)
      .then((response) => {
        if (response.status !== 200)
          throw new Error('Não foi possível obter os contratos')

        setPendencias(response.data)
        setPendenciasFiltred(response.data)
        setLoading('idle')
      })
      .catch(() => {
        // setLoading('error')
        // setMsgErro('Não foi possível obter os contratos')
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível obter o documento',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const handleJustify = (txt: string, context: AnexoPendencia) => {
    setPendenciasFiltred((prevState) =>
      prevState?.map((contract) => ({
        ...contract,
        anexos: contract?.anexos?.map((anexo) =>
          anexo.idMovDocumento === context.idMovDocumento
            ? {
                ...anexo,
                txJustificativa: txt
              }
            : anexo
        )
      }))
    )

    setPendencias((prevState) =>
      prevState?.map((contract) => ({
        ...contract,
        anexos: contract.anexos?.map((anexo) =>
          anexo.idMovDocumento === context.idMovDocumento
            ? {
                ...anexo,
                txJustificativa: txt
              }
            : anexo
        )
      }))
    )
  }

  interface addFileToAttachmentProps {
    file: File
    idMovDocumentoForAdd: number
  }
  const addFileToAttachment = async ({
    file,
    idMovDocumentoForAdd
  }: addFileToAttachmentProps) => {
    setLoading('loading')

    try {
      const fileBase64: any = await convertBase64(file)

      setPendencias((prevState) =>
        prevState?.map((contrato) => {
          return {
            ...contrato,
            anexos: contrato.anexos?.map((anexo) => ({
              ...anexo,
              ...(anexo.idMovDocumento === idMovDocumentoForAdd && {
                base64: fileBase64,
                filename: file.name
              })
            }))
          }
        })
      )

      setPendenciasFiltred((prevState) =>
        prevState?.map((contrato) => {
          return {
            ...contrato,
            anexos: contrato.anexos?.map((anexo) => ({
              ...anexo,
              ...(anexo.idMovDocumento === idMovDocumentoForAdd && {
                base64: fileBase64,
                filename: file.name
              })
            }))
          }
        })
      )

      setLoading('idle')
    } catch (error) {
      setLoading('error')
      setMsgErro('Não foi possível fazer o upload do arquivo')
    }
  }

  // Effect apenas criado para atualizar as o filtro de pendencias quando as pendencias forem atualizadas,
  // Isso ocorre por que quando é setado um documento, o filtro de pendencias precisa ser notificado e alterado
  // para exibição.
  useEffect(() => {
    handleFilter()
  }, [pendencias])

  const removeFileFromAttachment = (idMovDocumentoForRemove: number): void => {
    setLoading('loading')

    try {
      setPendencias((prevState) =>
        prevState?.map((contrato) => {
          return {
            ...contrato,
            anexos: contrato.anexos?.map(({ base64, filename, ...anexo }) => {
              if (base64) {
                if (anexo.idMovDocumento === idMovDocumentoForRemove) {
                  return {
                    ...anexo
                  }
                }

                return {
                  ...anexo,
                  base64,
                  filename
                }
              }

              return anexo
            })
          }
        })
      )

      setLoading('idle')
    } catch (error) {
      setLoading('error')
      setMsgErro('Não foi possível deletar o anexo, tente novamente')
    }
  }

  const handleSendAttachments = useCallback(
    (contractID: number) => {
      setLoading('loading')

      const MAX_FILE_SIZE = 120 * 1024 * 1024; 



      const newAttchmentFiles = pendencias
        .filter((contrato) => contrato.idContrato === contractID)
        ?.map((contrato) =>
          contrato.anexos
            .filter((anexo) => anexo.filename)
            ?.map((anexo) => ({
              cdDocto: contrato.cdDocumento.trim(),
              competencia: contrato.competencia,
              contratoId: contrato.idContrato,
              fornecedor: contrato.nmFornecedor,
              ...anexo
            }))
        )
        .flat()
        ?.map((anexo) => ({
          cdDocto: anexo.cdDocto,
          cdStatus: anexo.cdStatus,
          competencia: parseInt(moment(anexo.competencia).format('YYYYMM')),
          contratoId: anexo.contratoId,
          dtAnexado: moment().toISOString(),
          file: anexo.base64,
          fornecedor: anexo.fornecedor,
          gedExternalId: String(anexo.cdGedExternalId),
          idMovDocumentoItem: anexo.idMovDocumento,
          justificativa: anexo.txJustificativa || '',
          movDocumentoId: anexo.idMovDocumento,
          tipoPendenciaId: anexo.tipoPendenciaId,
          txFilename: anexo.filename,
          txVersao: ''
        }))

      const dontHaveDocument = newAttchmentFiles
        .map((anexo) => anexo.cdDocto)
        .includes('')

      if (dontHaveDocument) {
        setLoading('idle')
        showModal({
          type: 'alert',
          titleModal: 'Atenção!',
          message:
            'Fornecedor não possui documento de registro cadastrado, favor contatar analista CSN.',
          txtButtonConfirm: 'OK',
          hideButtonCancel: true
        })
        return
      }
      let fileSizeBiggerThanMax=false;
      newAttchmentFiles.forEach(x=>{
        if(base64Size(x.file)>MAX_FILE_SIZE){
          showModal({
            hideButtonCancel: true,
            message: 'Você está tentando anexar um arquivo com tamanho maior do que o permitido. Limite máximo: 120MB',
            txtButtonConfirm: 'OK',
            type: 'error',
          });
          fileSizeBiggerThanMax=true;
          setLoading('idle');

          return;
        }
      })
        if(fileSizeBiggerThanMax)return;





      MovDocumentItemServices()
        .CreateMovDocumentItemsGED(newAttchmentFiles)
        .then((response) => {
          if (response.status === 200) {
            setOpenSuccess(true)
          }

          setLoading('idle')
        })
        .catch((error: any) => {
          // setLoading('error')
          // setMsgErro('Não foi possível enviar os arquivos')
          setLoading('idle')
          if (
            error?.message?.includes('SMARTSHARE_OFF') ||
            error?.response?.data?.includes('SMARTSHARE_OFF')
          ) {
            showModal({
              hideButtonCancel: true,
              message:
                'Não foi possível obter o documento. Tente novamente em instantes.',
              txtButtonConfirm: 'Fechar',
              type: 'error'
            })
            return
          }
          showModal({
            hideButtonCancel: true,
            message:
              'Ocorreu um erro no servidor, tente novamente em instantes.',
            txtButtonConfirm: 'Fechar',
            type: 'error'
          })
        })
    },
    [pendencias]
  )

  useEffect(() => {
    getData()
  }, [])

  const filterTable = () => {
    if (!pesquisaGeralTxt) {
      return pendencias
    }

    

    return pendencias.filter(
      (contrato) =>
        contrato.nmFornecedor
          .toLowerCase()
          .includes(pesquisaGeralTxt.toLowerCase()) ||
        contrato.cdContrato
          .toLowerCase()
          .includes(pesquisaGeralTxt.toLowerCase())
    )
  }

  const base64Size = (base64String: string) => {
    const stringLength = base64String.length;
    const sizeInBytes = (stringLength * 3) / 4 - (base64String.endsWith('==') ? 2 : base64String.endsWith('=') ? 1 : 0);
    return sizeInBytes;
  }

  const handleFilter = () => {
    try {
      if (pesquisaGeralTxt != '') {
        const cpy: PendenciaCollapse[] = createArrayCopy(pendencias)

        const newArray = cpy?.map((contrato) => {
          return {
            ...contrato,
            anexos: contrato.anexos.filter((anexo) =>
              anexo.txDescricaoTipo
                ?.toLowerCase()
                .includes(pesquisaGeralTxt?.toLowerCase())
            )
          }
        })
        setPendenciasFiltred(newArray.filter((el) => el.anexos.length > 0))

        return
      }

      setPendenciasFiltred(pendencias)
    } catch (err: any) {
      setLoading('error')
      setMsgErro('Não foi possivel encontrar')
    }
  }

  return (
    <>
      <Card
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12)`}
        backgroundColor={COLORS.white}
        borderRadius={`0px 10px 0px 0px`}
      >
        <SearchPendency
          setPesquisaGeralTxt={setPesquisaGeralTxt}
          pesquisaGeralTxt={pesquisaGeralTxt}
          pendencias={pendencias}
        />
        {pendencias?.length === 0 ||
          (pendenciasFiltred?.length === 0 && (
            <Row
              alignItems="center"
              justifyContent="center"
              marginBottom={SPACING.spacing50}
              marginTop={SPACING.spacing20}
            >
              <Span
                text="Não existe nenhuma pendência"
                fontSize="1rem"
                fontWeight="bold"
                color={COLORS.info}
              />
            </Row>
          ))}
        {filterTable()?.map((collapse) => (
          <CollapseSearch
            key={collapse.cdContrato.toString()}
            data={{
              code: collapse.cdContrato,
              dataFim: FORMAT.formatDDMMYYYY(collapse.dtVigenciaFim),
              dataIni: FORMAT.formatDDMMYYYY(collapse.dtVigenciaInicio),
              empresa: collapse.nmFornecedor,
              titleCollapse: collapse.txObjetoContrato
            }}
            hideButton
          >
            <TablePendency
              tableData={collapse.anexos}
              cdContract={collapse.cdContrato}
              handleJustify={handleJustify}
              handleDeleteDocument={removeFileFromAttachment}
              handleUploadFile={addFileToAttachment}
            />
            <Row
              justifyContent="flex-end"
              alignItems="center"
              marginTop={SPACING.spacing20}
            >
              <Button
                onClick={() => handleSendAttachments(collapse.idContrato)}
                text="ENVIAR"
                disabled={!collapse?.anexos || collapse?.anexos.length === 0}
              />
            </Row>
          </CollapseSearch>
        ))}
      </Card>
      <SuccessModal
        open={openSuccess}
        type="sucess"
        message="Os anexos foram enviados para a análise"
        hideButtonCancel
        txtButtonConfirm="OK"
        handleConfirm={() => {
          setOpenSuccess(false)
          getData()
        }}
      />
    </>
  )
}
